import { initializeApp } from 'firebase/app'
import { FIREBASE_CONFIG } from 'config'
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics'
import { User } from 'types/user'
import { store } from 'store'
import { consentSelectors } from 'store/consent'

const firebaseConfig = JSON.parse(FIREBASE_CONFIG as string)

export const firebaseApp = initializeApp(firebaseConfig)

export class FirebaseAnalytics {
  private analytics?: Analytics

  private getAnalytics(): Analytics | undefined {
    if (!consentSelectors.analyticsAllowed(store.getState())) return undefined
    if (!this.analytics) this.analytics = getAnalytics(firebaseApp)
    return this.analytics
  }

  trackOpenChatArea(areaId: string | undefined, options: { user?: User; type: 'guest' | 'logged' }) {
    const analytics = this.getAnalytics()
    if (!analytics) return
    const { user, type } = options
    logEvent(analytics, 'chat_open', {
      chat_type: type,
      chat_area_id: areaId,
      chat_user_id: user?._id,
    })
  }
}

export const firebaseAnalytics = new FirebaseAnalytics()
